import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { API_URLS } from "@/config/urls";

export const UploadPlanGuidance = () => {
  const { t } = useTranslation();

  return (
    <div className="border-rw-main/20 bg-rw-main/5 space-y-3 rounded-lg border p-4">
      <h3 className="text-sm font-semibold text-gray-900">
        {t("common.increaseUploadCapacity")}
      </h3>
      <Button asChild variant="teal">
        <a
          href={`${API_URLS.WHALE}/subscription?display_basic=false`}
          target="_blank"
          rel="noreferrer"
        >
          {t("common.upgradeToPlus")}
          <ExternalLink aria-hidden="true" />
        </a>
      </Button>
      <p className="text-sm text-gray-600">
        {t("common.organizationPlanGuidance")}
      </p>
    </div>
  );
};
